import React from "react"
// import SocialLinks from '../../constants/socialLinks'
import Image from "gatsby-image"
import styled from "styled-components"
import { MDXRenderer } from "gatsby-plugin-mdx"
//...GatsbyImageSharpFixed

const Member = ({ frontmatter, excerpt, body }) => {
  const { title, image, date, category } = frontmatter
  return (
    <Wrapper>
      <Image fluid={image.childImageSharp.fluid} className="img" />
      <div className="info">
        {/*<p>{excerpt}</p>*/}
        {/* <SocialLinks styleClass="banner-icons" /> */}
        <MDXRenderer>{body}</MDXRenderer>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  font-family: var(-ff-primary);
  max-width: 400px;
  margin-bottom: 3rem;
  .info {
    text-align: center;
  }
  .img {
    max-width: 200px;
    margin: 0 auto 1rem auto;
  }
  .title {
    margin-right: 0.5rem;
  }
  .category,
  .title {
    font-weight: 700;
    color: var(--clr-black);
  }
  h3 {
    font-size: 1.5rem;
    font-weight: 400;
    margin-bottom: 1rem;
    text-transform: initial;
  }
  .underline {
    width: 5rem;
    height: 1px;
    background: var(--clr-grey-9);
    margin: 0 auto;
    margin-bottom: 1rem;
  }
  p {
    color: var(--clr-black);
  }
  table {
    margin-top: 1rem;
    text-align: left;
  }
  th {
    width: 6rem;
    vertical-align: top;
  }
  .table-space > td,
  .table-space > th {
    padding-bottom: 0.5rem;
  }
`

export default Member
